var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dui-book-cover",class:{ 'square': _vm.vm.isSquare }},[_c('span',{staticClass:"cover-image",style:({ 'background-image': _vm.vm.coverUrl ?
      'url(' + _vm.vm.coverUrl + ')' :
      '',
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }